import script from "./ViewComplaints.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewComplaints.vue?vue&type=script&setup=true&lang=js"

import "./ViewComplaints.vue?vue&type=style&index=0&id=4c203f68&lang=css"

const __exports__ = script;

export default __exports__